import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const MapaCoordenadaList = (props) => <DefaultDataTable data={props} />
